import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { signOutAction } from '../actions'

export type AssistantState = {
  isSideChatOpen: boolean
  activeThreadId?: string
}

const initialState: AssistantState = {
  activeThreadId: undefined,
  isSideChatOpen: false,
}

const key = 'assistant'

const AssistantSlice = createSlice({
  extraReducers: builder => {
    builder.addCase(signOutAction, state => {
      state.isSideChatOpen = initialState.isSideChatOpen
      state.activeThreadId = initialState.activeThreadId
    })
  },
  initialState,
  name: key,
  reducers: {
    setActiveThreadId(state, action: PayloadAction<string | undefined>) {
      state.activeThreadId = action.payload
    },
    toggleSideChat(state, action: PayloadAction<boolean | undefined>) {
      if (action.payload !== undefined) {
        state.isSideChatOpen = action.payload
      } else {
        state.isSideChatOpen = !state.isSideChatOpen
      }
    },
  },
})

export const AssistantReducer = persistReducer(
  {
    key,
    storage,
    whitelist: ['isSideChatOpen'],
  },
  AssistantSlice.reducer,
)

export const AssistantActions = AssistantSlice.actions
